import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { CoreCommonService } from '../../providers/services/common.service';


@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html'
})
export class RadioComponent implements OnChanges {
  @Input() field;
  @Input() form;
  @Input() type;
  @Output() controlReady = new EventEmitter<boolean>();
  constructor(private coreCommonService: CoreCommonService) { }

  /**
   * A callback method that is invoked if any data-bound properties change
   */
  ngOnChanges() {
    this.handleControlLoad();
    this.notifyControlLoadComplete();
  }

  /**
   * This method will handle control load
   * NOTE: Sequence of function calls need to be exactly same as below
   */
  private async handleControlLoad() {
    const value = this.form.get(this.field.logicalName).value
      ? this.form.get(this.field.logicalName).value
      : await this.coreCommonService.fetchDefaultValue(this.form.get(this.field.logicalName).defaultValueLookup, this.form);
    this.form.get(this.field.logicalName).setValue(value || null);
  }


  /**
   * This method will notify when control is ready
   */
  private notifyControlLoadComplete() {
    this.controlReady.emit(true);
  }

  /**
   * getter function to check mandatory fields
   */
  get isMandatory(): boolean {
    try {
      return this.field.validations.mandatory.value;
    } catch (error) {
      return false;
    }
  }

  /**
   * The trackBy function takes the index and the current item as arguments
   * and needs to return the unique identifier for this item
   * @param index - item index
   */
  trackByFn(index: number, item): number {
    if (!item) {
      return null;
    }
    return index;
  }
}
